import { Observable } from 'rxjs';
import { MatDialogRef, MatDialog } from '@angular/material'; // , MatDialogConfig
import { Injectable } from '@angular/core';
import { Component, NgModule } from '@angular/core';

@Component({
    selector: 'confirm-dialog',
    template: `
        <h3>{{ title }}</h3>
        <div class="body" [innerHTML]="message"></div>
        <div class="dialog-buttons">
            <button mat-button class="mat-raised confirm"
                (click)="dialogRef.close(true)">확인</button>
            <button mat-button class="mat-raised cancel"
                (click)="dialogRef.close(false)">취소</button>
        </div>
    `,
    styles: [
        'h3 {text-align: center;}',
        '.body {padding: 30px 0;line-height: 25px;}',
        '.dialog-buttons {display: flex;}',
        'button {flex: 1;    display: block;min-height: 45px;border-radius: 2px;line-height: 20px;margin-right: 5px;   border-width: 1px; border-style: solid; border-color: #b2b2b2;background-color: #f8f8f8;color: #444;padding: 0 12px;}',
        '.confirm {border-color: #0c60ee;background-color: #387ef5;color: #fff;}'
    ]
})

export class ConfirmDialog {
    public title: string;
    public message: string;
    constructor(public dialogRef: MatDialogRef<ConfirmDialog>) {
    }
}
// DialogsService 는 shared.module에서 별도로 처리
// 아래 모듈은 shared.module.에서 호출
@NgModule({
    declarations: [
        ConfirmDialog
    ],
    imports: [],
    exports: [
        ConfirmDialog
    ],
    entryComponents: [
        ConfirmDialog
    ]
})
export class DialogModule { }

/**
 *
 * https: // medium.com/@tarik.nzl/making-use-of-dialogs-in-material-2-mddialog-7533d27df41
 */
@Injectable()
export class DialogService {

    constructor(private dialog: MatDialog) { }

    public confirm(title: string, message: string): Observable<boolean> {

        let dialogRef: MatDialogRef<ConfirmDialog>;

        dialogRef = this.dialog.open(ConfirmDialog);
        dialogRef.componentInstance.title = title;
        dialogRef.componentInstance.message = message;

        return dialogRef.afterClosed();

    }
}
